import React, { useEffect, useRef, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { fetchCoachCategories } from "../../redux/features/coach/actions/authAction";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { enterPrisesPaths } from "../../routes/enterprises";

const Enterprise = () => {
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const { categoryList, isLoading } = useSelector((state) => state.coach.auth);

  const user = { name: "find-a-coach", role: "coach" };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const { state } = useLocation();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (isLoading2 || isLoading) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      {({ openSignUp }) => (
        <>
          <div className="ct_nuglow_yellow_shape_main_34 mb-0  mt-0 ct_enterprice_light_yellow_shape ">
            <section class="ct_px_40    pt-5">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div
                    class="col-xxl-5 col-xl-5 col-md-5 mb-4 mb-md-0 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="pb-5">
                      <h2 class="ct_fs_65_new mb-0" style={{ maxWidth: "531px" }}>
                        {" "}
                        Unlock <span className="ct_yellow_text"> Doors </span>to
                        New Opportunities
                      </h2>
                      <p
                        class="mb-0 ct_mt_30 ct_fs_24_new "
                        style={{ maxWidth: "534px" }}
                      >
                        Fuel your growth by connecting with trusted experts and
                        scalable solutions,all in one seamless platform.
                      </p>

                      <div class="ct_mt_30">
                        <a
                          class="ct_yellow_btn ct_sky_blue_btn   px-5 ct_fit_content  "
                          onClick={(e) => {
                            e.preventDefault();
                            openSignUp();
                          }}
                        >
                          Get Started
                        </a>
                      </div>
                      <div style={{ marginTop: "200px" }}>
                        <p className="ct_fs_18 mb-0">
                          Trusted by <span className="ct_yellow_text">50K</span>{" "}
                          Users
                        </p>
                        <div className="d-flex align-items-center gap-5 ct_mt_30">
                          <div>
                            <h1 className="ct_fs_48 ct_mb_10">100+</h1>
                            <p className="mb-0 ct_fs_18 ct_darkblue_text">
                              A wide range of industries
                            </p>
                          </div>
                          <div>
                            <h1 className="ct_fs_48 ct_mb_10">25k+</h1>
                            <p className="mb-0 ct_fs_18 ct_darkblue_text">
                              Found their dream jobs
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xxl-7 col-xl-7 col-md-7 mb-4 mb-md-0"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_interprise_puzzle_images">
                      <div className="ct_puzzle_row_1">
                        <img src="../assets/img/enterprice_img_puzzle_1.png" />
                        <img src="../assets/img/enterprice_img_puzzle_2.png" />
                      </div>
                      <div className="ct_puzzle_row_2">
                        <img src="../assets/img/enterprice_img_puzzle_3.png" />
                        <img
                          className="ct_cursor_pointer"
                          src="../assets/img/enterprice_img_puzzle_4.png"
                          onClick={() => navigate(coachPaths?.MatchTalent)}
                        />
                        <img src="../assets/img/enterprice_img_puzzle_5.png" />
                      </div>
                      <div className="ct_puzzle_row_3">
                        <img
                          className="ct_cursor_pointer"
                          src="../assets/img/enterprice_img_puzzle_6.png"
                          onClick={() => navigate(coachPaths.find_job)}
                        />
                        <img src="../assets/img/enterprice_img_puzzle_7.png" />
                        <img src="../assets/img/enterprice_img_puzzle_8.png" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              class="ct_sky_blue_bg ct_py_80 ct_px_40"
              style={{ backgroundColor: "hsl(199deg 64% 73% / 20%)" }}
            >
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <h2 class="ct_fs_40 ct_pb_60  text-center mb-0 ct_darkblue_text">
                      We Match Talent with Your Needs
                    </h2>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-down"
                    data-aos-duration="1000"
                  >
                    <h4 class="ct_darksky_blue_text  ct_fs_32 mb-3">
                      Diverse Expertise
                    </h4>

                    <figure class="mb-0 ct_coach_created_card ct_coach_created_w_90">
                      <div
                        class="ct_coach_created_img"
                        style={{ aspectRatio: "auto" }}
                      >
                        <img
                          alt=""
                          src="/../assets/img/match_talent_img_1.png"
                          className="ct_img_h_267"
                        />
                      </div>
                      <figcaption class="mt-3">
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_20 ct_para_scroll ct_custom_scroll"
                          style={{ maxWidth: "366px" }}
                        >
                          Access top talent in tech, design, and strategy. Hire
                          across roles and industries all in one place.
                        </p>
                        <div className="mt-3">
                          <a
                            class="ct_yellow_btn ct_fit_content ct_h_44 px-4"
                            style={{
                              color: "var(--dark_blue)",
                            }}
                            onClick={() =>
                              navigate(coachPaths?.NuGlowSubscription)
                            }
                          >
                            Get Started{" "}
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                  >
                    <h4 class="ct_darksky_blue_text  ct_fs_32 mb-3">
                      Smart Matching
                    </h4>

                    <figure class="mb-0 ct_coach_created_card ct_coach_created_w_90">
                      <div
                        class="ct_coach_created_img"
                        style={{ aspectRatio: "auto" }}
                      >
                        <img
                          alt=""
                          src="/../assets/img/match_talent_img_2.png"
                          className="ct_img_h_267"
                        />
                      </div>
                      <figcaption class="mt-3">
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_20 ct_para_scroll ct_custom_scroll"
                          style={{ maxWidth: "349px" }}
                        >
                          Get matched with freelancers who fit your project.
                          Filter by skills, experience level, and availability.
                        </p>
                        <div className="mt-3">
                          <a
                            class="ct_yellow_btn ct_fit_content ct_h_44 px-4"
                            style={{
                              color: "var(--dark_blue)",
                            }}
                            onClick={() =>
                              navigate(coachPaths?.NuForgeSubscription)
                            }
                          >
                            Get Started{" "}
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-down"
                    data-aos-duration="2000"
                  >
                    <h4 class="ct_darksky_blue_text  ct_fs_32 mb-3">
                      Quality Assured
                    </h4>

                    <figure class="mb-0 ct_coach_created_card ct_coach_created_w_90">
                      <div
                        class="ct_coach_created_img"
                        style={{ aspectRatio: "auto" }}
                      >
                        <img
                          alt=""
                          src="/../assets/img/match_talent_img_3.png"
                          className="ct_img_h_267"
                        />
                      </div>
                      <figcaption class="mt-3">
                        <p
                          class="mb-0 ct_darkblue_text ct_fs_20 ct_para_scroll ct_custom_scroll"
                          style={{ maxWidth: "366px" }}
                        >
                          Work with professionals trusted by real clients. Every
                          profile is reviewed and backed by ratings
                        </p>
                        <div className="mt-3">
                          <a
                            class="ct_yellow_btn ct_fit_content ct_h_44 px-4"
                            style={{
                              color: "var(--dark_blue)",
                            }}
                            onClick={() =>
                              navigate(coachPaths?.NuStarSubscription)
                            }
                          >
                            Get Started{" "}
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </section>

            <section class=" ct_px_40 ct_py_130">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_img">
                      <img
                        src="../assets/img/Rectangle_4583.png"
                        alt=""
                        style={{ objectFit: "cover", objectPosition: "right" }}
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_content">
                      <h4 class="ct_fs_24 ct_orange_text">For Enterprises</h4>
                      <h3 class="ct_fs_32 ct_darksky_blue_text ">
                        How it Works?
                      </h3>
                    </div>
                    <div class="row mt-5">
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card">
                          <img
                            src="../assets/img/ph_magnifying-glass-fill.png"
                            alt=""
                            className="ct_w_50_345"
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Hire Smarter, Faster
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "188px" }}
                            >
                              Find trusted freelancers and consultants from
                              different fields,ready to get the job done.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card">
                          <img
                            src="../assets/img/work_icon_2.png"
                            alt=""
                            className="ct_w_50_345"
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Collaborate with Confidence
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "217px" }}
                            >
                              Manage projects, co-create solutions, and scale your
                              team with no hassle.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card">
                          <img
                            src="../assets/img/bxs_trophy.png"
                            alt=""
                            className="ct_w_50_340 "
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Boost Growth Potential
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "221px" }}
                            >
                              From helpful coaching to shared investments, improve
                              your work with the right partners.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="d-flex align-items-center ct_flex_col_991 ct_row_reverse_991">
              <div
                className="ct_looking_for_work_bg  ct_looking_for_work_bg_left ct_w_calc_100_309    ct_pt_80_ps_50_pb_80_pe_85"
                style={{ backgroundColor: "var(--dark_blue)" }}
              >
                <div class="row gx-5">
                  <div
                    className="col-xl-4 col-lg-6 col-md-6 ct_mb_30 ct_cursor_pointer"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                    onClick={() => navigate(enterPrisesPaths?.DesignService)}
                  >
                    <div
                      className="ct_opportunity_card ct_pt_40_px_40_pb_60"
                      style={{ backgroundColor: "#219EBC" }}
                    >
                      <div>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M25.8875 8.80001C25.4625 9.22501 25.05 9.63751 25.0375 10.05C25 10.45 25.425 10.8625 25.825 11.25C26.425 11.875 27.0125 12.4375 26.9875 13.05C26.9625 13.6625 26.325 14.3 25.6875 14.925L20.525 20.1L18.75 18.325L24.0625 13.025L22.8625 11.825L21.0875 13.5875L16.4 8.90001L21.2 4.11251C21.6875 3.62501 22.5 3.62501 22.9625 4.11251L25.8875 7.03751C26.375 7.50001 26.375 8.31251 25.8875 8.80001ZM3.75 21.5625L15.7 9.60001L20.3875 14.2875L8.4375 26.25H3.75V21.5625Z"
                            fill="#FFB703"
                          />
                        </svg>
                      </div>
                      <div className="ct_mt_30">
                        <h4 className="ct_fs_24_new text-white mb-3">
                          UI/UX Design
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xl-4 col-lg-6 col-md-6 ct_mb_30 ct_cursor_pointer"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                    onClick={() => navigate(enterPrisesPaths?.SalesService)}
                  >
                    <div
                      className="ct_opportunity_card ct_pt_40_px_40_pb_60"
                      style={{ backgroundColor: "#219EBC" }}
                    >
                      <div>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.5 6.25H17.5V23.75H12.5V6.25ZM6.25 23.75V12.5H11.25V23.75H6.25ZM8.75 6.25C8.08696 6.25 7.45107 6.51339 6.98223 6.98223C6.51339 7.45107 6.25 8.08696 6.25 8.75C6.25 9.41304 6.51339 10.0489 6.98223 10.5178C7.45107 10.9866 8.08696 11.25 8.75 11.25C9.41304 11.25 10.0489 10.9866 10.5178 10.5178C10.9866 10.0489 11.25 9.41304 11.25 8.75C11.25 8.08696 10.9866 7.45107 10.5178 6.98223C10.0489 6.51339 9.41304 6.25 8.75 6.25ZM18.75 6.25H23.75V11.25H18.75V6.25ZM23.75 12.5H18.75V17.5H23.75V12.5Z"
                            fill="#FFB703"
                          />
                        </svg>
                      </div>
                      <div className="ct_mt_30">
                        <h4 className="ct_fs_24_new text-white mb-3">Sales</h4>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xl-4 col-lg-6 col-md-6 ct_mb_30"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                  >
                    <div
                      className="ct_opportunity_card ct_pt_40_px_40_pb_60"
                      style={{ backgroundColor: "#219EBC" }}
                    >
                      <div>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.75 18.75H16.25V21.25H13.75V18.75ZM13.75 8.75H16.25V16.25H13.75V8.75Z"
                            fill="#FFB703"
                          />
                          <path
                            d="M6.26172 1.25V28.75H23.7492V1.25H6.26172ZM21.2492 22.5H8.74922V7.5H21.2492V22.5Z"
                            fill="#FFB703"
                          />
                        </svg>
                      </div>
                      <div className="ct_mt_30">
                        <h4 className="ct_fs_24_new text-white mb-3">
                          Mobile App Development
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xl-4 col-lg-6 col-md-6 ct_mb_30 ct_cursor_pointer"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                    onClick={() => navigate(enterPrisesPaths?.DesignService)}
                  >
                    <div
                      className="ct_opportunity_card ct_pt_40_px_40_pb_60"
                      style={{ backgroundColor: "#219EBC" }}
                    >
                      <div>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M26.2539 2.505H3.75391C3.09147 2.50698 2.45674 2.77101 1.98832 3.23942C1.51991 3.70784 1.25588 4.34257 1.25391 5.00501V20.005C1.25588 20.6674 1.51991 21.3022 1.98832 21.7706C2.45674 22.239 3.09147 22.503 3.75391 22.505H12.5039V25.005H10.0039V27.505H20.0039V25.005H17.5039V22.505H26.2539C26.9163 22.503 27.5511 22.239 28.0195 21.7706C28.4879 21.3022 28.7519 20.6674 28.7539 20.005V5.00501C28.7519 4.34257 28.4879 3.70784 28.0195 3.23942C27.5511 2.77101 26.9163 2.50698 26.2539 2.505ZM13.4439 17.0875L7.50641 11.15L9.27391 9.38376L13.4439 13.5538L20.7377 6.25875L22.5064 8.0275L13.4439 17.0875Z"
                            fill="#FFB703"
                          />
                        </svg>
                      </div>
                      <div className="ct_mt_30">
                        <h4 className="ct_fs_24_new text-white mb-3">
                          Mobile Design
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xl-4 col-lg-6 col-md-6 ct_mb_30 ct_cursor_pointer"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                    onClick={() => navigate(enterPrisesPaths?.marketing_services)}
                  >
                    <div
                      className="ct_opportunity_card ct_pt_40_px_40_pb_60"
                      style={{ backgroundColor: "#219EBC" }}
                    >
                      <div>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M25 5H5C4.66848 5 4.35054 5.1317 4.11612 5.36612C3.8817 5.60054 3.75 5.91848 3.75 6.25V23.75C3.75 24.0815 3.8817 24.3995 4.11612 24.6339C4.35054 24.8683 4.66848 25 5 25H25C25.3315 25 25.6495 24.8683 25.8839 24.6339C26.1183 24.3995 26.25 24.0815 26.25 23.75V6.25C26.25 5.91848 26.1183 5.60054 25.8839 5.36612C25.6495 5.1317 25.3315 5 25 5ZM5 2.5C4.00544 2.5 3.05161 2.89509 2.34835 3.59835C1.64509 4.30161 1.25 5.25544 1.25 6.25V23.75C1.25 24.7446 1.64509 25.6984 2.34835 26.4017C3.05161 27.1049 4.00544 27.5 5 27.5H25C25.9946 27.5 26.9484 27.1049 27.6517 26.4017C28.3549 25.6984 28.75 24.7446 28.75 23.75V6.25C28.75 5.25544 28.3549 4.30161 27.6517 3.59835C26.9484 2.89509 25.9946 2.5 25 2.5H5ZM7.5 8.75H10V11.25H7.5V8.75ZM13.75 8.75C13.4185 8.75 13.1005 8.8817 12.8661 9.11612C12.6317 9.35054 12.5 9.66848 12.5 10C12.5 10.3315 12.6317 10.6495 12.8661 10.8839C13.1005 11.1183 13.4185 11.25 13.75 11.25H21.25C21.5815 11.25 21.8995 11.1183 22.1339 10.8839C22.3683 10.6495 22.5 10.3315 22.5 10C22.5 9.66848 22.3683 9.35054 22.1339 9.11612C21.8995 8.8817 21.5815 8.75 21.25 8.75H13.75ZM10 13.75H7.5V16.25H10V13.75ZM12.5 15C12.5 14.6685 12.6317 14.3505 12.8661 14.1161C13.1005 13.8817 13.4185 13.75 13.75 13.75H21.25C21.5815 13.75 21.8995 13.8817 22.1339 14.1161C22.3683 14.3505 22.5 14.6685 22.5 15C22.5 15.3315 22.3683 15.6495 22.1339 15.8839C21.8995 16.1183 21.5815 16.25 21.25 16.25H13.75C13.4185 16.25 13.1005 16.1183 12.8661 15.8839C12.6317 15.6495 12.5 15.3315 12.5 15ZM10 18.75H7.5V21.25H10V18.75ZM12.5 20C12.5 19.6685 12.6317 19.3505 12.8661 19.1161C13.1005 18.8817 13.4185 18.75 13.75 18.75H21.25C21.5815 18.75 21.8995 18.8817 22.1339 19.1161C22.3683 19.3505 22.5 19.6685 22.5 20C22.5 20.3315 22.3683 20.6495 22.1339 20.8839C21.8995 21.1183 21.5815 21.25 21.25 21.25H13.75C13.4185 21.25 13.1005 21.1183 12.8661 20.8839C12.6317 20.6495 12.5 20.3315 12.5 20Z"
                            fill="#FFB703"
                          />
                        </svg>
                      </div>
                      <div className="ct_mt_30">
                        <h4 className="ct_fs_24_new text-white mb-3">
                          Marketing
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xl-4 col-lg-6 col-md-6 ct_mb_30 ct_cursor_pointer"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                    onClick={() => navigate(enterPrisesPaths?.customer_service)}
                  >
                    <div
                      className="ct_opportunity_card ct_pt_40_px_40_pb_60"
                      style={{ backgroundColor: "#219EBC" }}
                    >
                      <div>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15 1.25C12.0163 1.25 9.15483 2.43526 7.04505 4.54505C4.93526 6.65483 3.75 9.51631 3.75 12.5V21.25C3.75 23.325 5.425 25 7.5 25H11.25V15H6.25V12.5C6.25 7.6625 10.1625 3.75 15 3.75C19.8375 3.75 23.75 7.6625 23.75 12.5V15H18.75V25H22.5C24.575 25 26.25 23.325 26.25 21.25V12.5C26.25 9.51631 25.0647 6.65483 22.955 4.54505C20.8452 2.43526 17.9837 1.25 15 1.25Z"
                            fill="#FFB703"
                          />
                        </svg>
                      </div>
                      <div className="ct_mt_30">
                        <h4 className="ct_fs_24_new text-white mb-3">
                          Customer Service
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ct_ps_32_pe_50">
                <h3 className="ct_fs_35 ct_darkblue_text ct_mb_50">
                  Explore IT Services
                </h3>
                <button
                  className="ct_yellow_btn w-100"
                  onClick={() => navigate(enterPrisesPaths?.ExploreService)}
                >
                  View Our Services
                </button>
              </div>
            </section>

            <div className="ct_nuglow_yellow_shape_main_34 ct_mb_100 ct_enterprice_light_yellow_shape ">
              <section class="  ct_px_40 ct_py_130 ct_pb_80 ">
                <div class="container-fluid">
                  <div class="row">
                    <div
                      class="col-lg-4 mb-4 mb-lg-0"
                      data-aos="fade-right"
                      data-aos-duration="1500"
                    >
                      <div class="d-grid h-100 pt-2 pb-5">
                        <h2
                          class="ct_fs_40 ct_darkblue_text"
                          style={{ maxWidth: "300px" }}
                        >
                          Real Stories, real{" "}
                          <span class="ct_darksky_blue_text">success</span>
                        </h2>
                        <div className="ct_arrows mt-auto">
                          <button className="ct_prev ct_arrow_btn" ref={prevRef}>
                            <i class="fa-solid fa-arrow-left"></i>
                          </button>
                          <button className="ct_next ct_arrow_btn" ref={nextRef}>
                            <i class="fa-solid fa-arrow-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-lg-8 mb-4 mb-lg-0"
                      data-aos="fade-left"
                      data-aos-duration="1500"
                    >
                      <Swiper
                        modules={[Navigation, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={1}
                        loop={true}
                        autoplay={{ delay: 2500 }}
                        navigation={{
                          prevEl: prevRef.current,
                          nextEl: nextRef.current,
                        }}
                        onBeforeInit={(swiper) => {
                          swiper.params.navigation.prevEl = prevRef.current;
                          swiper.params.navigation.nextEl = nextRef.current;
                        }}
                        className="ct_real_stories_slider"
                      >
                        {/* Slide 1 */}
                        <SwiperSlide>
                          <div className="ct_story_slide_card">
                            <div className="ct_story_user_img">
                              <img
                                src="../assets/img/reacl_stories_img_slider_123.png"
                                alt=""
                              />
                            </div>
                            <div>
                              <div className="ct_orange_text mb-3">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                              </div>
                              <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                                From Passion to Profession
                              </h3>
                              <p
                                className="ct_fS_18 ct_darkblue_text"
                                style={{ maxWidth: "402px" }}
                              >
                                Starting as a freelance developer felt
                                overwhelming. But through NuGlow, I built a solid
                                portfolio and connected with startups that valued
                                my work. Today, I lead a team and help others find
                                their way too.
                              </p>
                              <div className="mt-5">
                                <h4 className="ct_fs_20 ct_darkblue_text">
                                  Amelia Carter
                                </h4>
                                <p className="ct_fs_18 ct_darkblue_text">
                                  Head of Product at BrightWave Solutions
                                </p>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="ct_story_slide_card">
                            <div className="ct_story_user_img">
                              <img
                                src="../assets/img/pexels-fauxels-3182834.png"
                                alt=""
                              />
                            </div>
                            <div>
                              <div className="ct_orange_text mb-3">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                              </div>
                              <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                                Dream Clients, Real Impact
                              </h3>
                              <p
                                className="ct_fS_18 ct_darkblue_text"
                                style={{ maxWidth: "402px" }}
                              >
                                With NuGlow, I went from inconsistent gigs to landing long-term clients. The exposure and experience helped me grow into a leadership role much faster than I imagined
                              </p>
                              <div className="mt-5">
                                <h4 className="ct_fs_20 ct_darkblue_text">
                                  Sophia Bennett
                                </h4>
                                <p className="ct_fs_18 ct_darkblue_text">
                                  Head of Digital Products at NovaSphere
                                </p>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="ct_story_slide_card">
                            <div className="ct_story_user_img">
                              <img
                                src="../assets/img/pexels-fauxels-31828341245.png"
                                alt=""
                              />
                            </div>
                            <div>
                              <div className="ct_orange_text mb-3">
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                                <i className="fa-solid fa-star"></i>
                              </div>

                              <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                                Breaking Through the Noise
                              </h3>

                              <p
                                className="ct_fS_18 ct_darkblue_text"
                                style={{ maxWidth: "402px" }}
                              >
                                I struggled for years to get noticed. NuGlow changed everything my first premium project opened doors I never thought possible. Now, I manage large-scale product launches across industries.
                              </p>

                              <div className="mt-5">
                                <h4 className="ct_fs_20 ct_darkblue_text">
                                  Ethan Moore
                                </h4>
                                <p className="ct_fs_18 ct_darkblue_text">
                                  Senior Product Manager at VeloTech
                                </p>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      </Swiper>
                    </div>
                  </div>
                </div>
              </section>

              <section class=" ct_px_40 ">
                <div class="container-fluid">
                  <div class="row align-items-center">
                    <div
                      class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                      data-aos="fade-right"
                      data-aos-duration="1500"
                    >
                      <div class="ct_how_work_img">
                        <img
                          src="../assets/img/Rectangle_89953.png"
                          alt=""
                          style={{ objectFit: "cover", objectPosition: "right" }}
                        />
                      </div>
                    </div>
                    <div
                      class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                      data-aos="fade-left"
                      data-aos-duration="1500"
                    >
                      <div class="ct_how_work_content">
                        <h4 class="ct_fs_24 ct_orange_text">For Freelancers</h4>
                        <h3 class="ct_fs_32 ct_darksky_blue_text ">
                          Your Team-Building Revolution Starts Here
                        </h3>
                      </div>
                      <div class="row mt-5">
                        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                          <div class="ct_how_work_card p-3">
                            <img
                              src="../assets/img/Apply_icon_1.png"
                              alt=""
                              className="ct_w_50_340 ct_h_30_img_new "
                            />
                            <div class="pt-4">
                              <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                                Find Jobs{" "}
                              </h5>
                              <p
                                class="mb-0 ct_fs_16"
                                style={{ maxWidth: "175px" }}
                              >
                                Level up with high-value freelance work.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                          <div class="ct_how_work_card p-3">
                            <img
                              src="../assets/img/dashicons_welcome-learn-more.png"
                              alt=""
                              className="ct_w_50_340 ct_h_30_img_new"
                            />
                            <div class="pt-4">
                              <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                                Learn
                              </h5>
                              <p
                                class="mb-0 ct_fs_16"
                                style={{ maxWidth: "205px" }}
                              >
                                Start your journey with beginner-friendly
                                projects.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                          <div class="ct_how_work_card p-3">
                            <img
                              src="../assets/img/uim_bag_icon_2.png"
                              alt=""
                              className="ct_w_50_340 ct_h_30_img_new"
                            />
                            <div class="pt-4">
                              <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                                Get Hired
                              </h5>
                              <p
                                class="mb-0 ct_fs_16"
                                style={{ maxWidth: "215px" }}
                              >
                                Stand out as a top freelancer with exclusive
                                opportunities.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <section
              class="ct_looking_for_work_bg      ct_p_111_y_106"
              style={{ backgroundColor: "#219EBC" }}
            >
              <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                <div class="text-white">
                  <h4 class="ct_fs_36 mb-4 ct_yellow_text">
                    Unlock your potential.
                  </h4>
                  <p class="mb-0 ct_fs_18" style={{ maxWidth: "540px" }}>
                    You’ve got the skills, we’ll help you go further. Join a
                    global network of top IT professionals and find projects that
                    match your ambition.
                  </p>
                </div>
                <div class="ct_flex_shrink_0">
                  <a
                    class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                    onClick={() => navigate(coachPaths?.freelance)}
                  >
                    Join Us
                  </a>
                </div>
              </div>
            </section>

            <section class=" ct_px_40 ct_py_130">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div
                    class="col-lg-8 mb-4 mb-lg-0 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_content">
                      <h4 class="ct_fs_24 ct_orange_text">For Coaches</h4>
                      <h3 class="ct_fs_32 ct_darksky_blue_text ">
                        Lead, Transform, Thrive
                      </h3>
                    </div>
                    <div class="row mt-5">
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/vaadin_group.png"
                            alt=""
                            className="ct_w_50_340 ct_h_30_img_new"
                          />
                          <div class="pt-4">
                            <h5
                              className="ct_fs_20 ct_dakrblue_text mb-4"
                              style={{ maxWidth: "241px" }}
                            >
                              Empower High-Performing Teams
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "226px" }}
                            >
                              Provide leadership coaching and development to help
                              enterprises scale with confidence.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/fa6-solid_handshake.png"
                            alt=""
                            className="ct_w_50_340 ct_h_30_img_new"
                          />
                          <div class="pt-4">
                            <h5
                              className="ct_fs_20 ct_dakrblue_text mb-4"
                              style={{ maxWidth: "241px" }}
                            >
                              Establish Yourself as a Strategic Partner
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "208px" }}
                            >
                              Apply your expertise to co-create impactful
                              solutions and drive sustainable growth.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/work_icon_1.png"
                            alt=""
                            className="ct_w_50_340 ct_h_30_img_new"
                          />
                          <div class="pt-4">
                            <h5
                              className="ct_fs_20 ct_dakrblue_text mb-4"
                              style={{ maxWidth: "241px" }}
                            >
                              Scale Your Impact with CoachingHub
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "259px" }}
                            >
                              Leverage tailored tools and a trusted network to
                              expand your coaching practice.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-4 mb-4 mb-lg-0  ps-lg-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_img">
                      <img
                        src="../assets/img/Rectangle_3_8599664.png"
                        alt=""
                        style={{ objectFit: "contain", objectPosition: "top" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              class="ct_looking_for_work_bg  ct_looking_for_work_bg_left    ct_p_111_y_106"
              style={{ backgroundColor: "var(--yellow)" }}
            >
              <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                <div class="text-white">
                  <h4 class="ct_fs_36 mb-4 ct_darkblue_text">
                    Start your growth journey today with us.
                  </h4>
                  <p class="mb-0 ct_fs_18" style={{ maxWidth: "632px" }}>
                    Shaped by your feedback, our platform evolves with you — every
                    step of the way.
                  </p>
                </div>
                <div class="ct_flex_shrink_0">
                  <a
                    class="ct_yellow_btn ct_light_sky_btn ct_flex_1 px-5"
                    onClick={() => navigate(coachPaths?.BecomeCoach)}
                  >
                    Start Now
                  </a>
                </div>
              </div>
            </section>

            <section class="  pt-0 ct_mt_100 ct_faq_section_shape_yellow ct_faq_section_shape_blue">
              <div class="container-fluid">
                <div class="row align-items-center ct_px_40">
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_img">
                      <img
                        src="../assets/img/Rectangle_789654.png"
                        alt=""
                        style={{ objectFit: "cover", objectPosition: "right" }}
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_content">
                      <h4 class="ct_fs_24 ct_orange_text">For Entrepreneurs</h4>
                      <h3 class="ct_fs_32 ct_darksky_blue_text ">
                        Fund & Grow Your Bussiness
                      </h3>
                    </div>
                    <div class="row mt-5">
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/minus_sheild_icon.png"
                            alt=""
                            className="ct_w_50_330"
                          />
                          <div class="pt-4">
                            <h5
                              className="ct_fs_20 ct_dakrblue_text mb-4"
                              style={{ maxWidth: "288px" }}
                            >
                              Invest in Trusted Talent & Ventures
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "208px" }}
                            >
                              Support vetted freelancers and promising businesses
                              with strong growth potential.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/direction_both_icon.png"
                            alt=""
                            className="ct_w_50_330"
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Explore Flexible Funding Options
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "226px" }}
                            >
                              Access equity, grants, and partnership models
                              designed to fit your investment goals.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/streamline_sprout-solid.png"
                            alt=""
                            className="ct_w_50_330 "
                          />
                          <div class="pt-4">
                            <h5
                              className="ct_fs_20 ct_dakrblue_text mb-4"
                              style={{ maxWidth: "256px" }}
                            >
                              Engage with Purpose-Driven Founders
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "227px" }}
                            >
                              Connect with innovative projects focused on
                              meaningful, measurable impact.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="ct_looking_for_work_bg   my-5   ct_p_111_y_106"
                style={{ backgroundColor: "var(--orange)" }}
              >
                <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                  <div class="text-white">
                    <h4 class="ct_fs_36 mb-4 ct_darkblue_text">
                      Entrepreneur Funding Gateway
                    </h4>
                    <p class="mb-0 ct_fs_18" style={{ maxWidth: "500px" }}>
                      Share your vision, attract investors, and secure the funding
                      your project deserves.
                    </p>
                  </div>
                  <div class="ct_flex_shrink_0">
                    <a
                      class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                      onClick={(e) => {
                        e.preventDefault();
                        openSignUp();
                      }}
                    >
                      Get Funded
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}
    </MenuLayout>
  );
};

export default Enterprise;
